'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwipeableViews = require('./SwipeableViews');

var _SwipeableViews2 = _interopRequireDefault(_SwipeableViews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SwipeableViews2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views/lib/index.js
// module id = 395
// module chunks = 3